import { Link } from "react-router-dom"
import React, {useEffect, useState} from "react"
// import HomeContainer from "../Container/HomeContainer";
import HomeContainer from "../Container/HomeContainer2"
import TeacherResume from "./TeacherResume.redux"
// import TeacherResume from "./TeacherResume";
// import axios from "axios";
// import { useArray, useForceUpdate } from "../../Hook";
// import { PORT } from "../../config";
import Spinner from "../../Components/Spinner/Spinner"

//Yuan:redux
import { connect } from "react-redux"
// import { store } from "../../redux/store";
import { createStructuredSelector } from "reselect"
//Yuan-selector
import { selectUserDetails } from "../../redux/homePage/homePage.selectors"
import { updateToRoot } from "../../redux/homePage/homePage.actions"
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import Tour from "reactour";
import { API } from "../../API"

const Resume2 = ({ user, updateToRoot }) => {
  // const [user, setUser] = useState(JSON.parse(window.localStorage.user));
  let [showTour, setShowTour] = useState(
    JSON.parse(window.localStorage.getItem('firstTime')) || false,
  )

  useEffect(() => {
    API.getUserSafeData().then(res => {
      updateToRoot(res.data?.user)
    })
  }, [])

  const tourSteps = [
    {
      content:
        (<React.Fragment>
            WAIT! We advise that you prepare your documents for uploading before completing the qualifications section
            of your Resume. Watch
            <b style={{color: "DodgerBlue", cursor: "pointer"}}
               onClick={() => window.open("https://drive.google.com/file/d/1f8JcC5u2RhEVAYvdi_BxVJRmQfYaz_He/view?usp=drivesdk", "_blank")}> this
              video </b>
            for instructions on reducing the file size of your documents.
          </React.Fragment>
        )
    },
  ]

  const closeTour = () => {
    setShowTour(false)
    window.localStorage.setItem('firstTime', 'false')
  }

  //*******NOTICE *************/
  //Resume footer (Police check box && WWCC box) has been replaced by Police Check Button and WWCC button which located under TABS
  //Therefore, at return: footer={null}, If we want to active footer again: footer={pageFooter}
  //isShowPoliceCheckWwcc = {true} Show Police check & WWCC Button
  //************************* */
  // const pageFooter = (
  //   <div className="row prof-otherinfo-row">
  //     <div className="col-2 profile-otherinfo-box-container profile-otherinfo-box-container-smaller">
  //       <div className="profile-otherinfo-box">
  //         {user.police_check_url ? (
  //           <Link
  //             to={{ pathname: `/PdfViewer?id=${user.police_check_url}` }}
  //             target="_blank"
  //           >
  //             <div className="profile-otherinfo-box-header d-flex justify-content-between">
  //               <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-cont-col-4 ml-3">
  //                 <div className="mdi mdi-fingerprint"> </div>
  //               </div>
  //               {user.police_check_verification_status ? (
  //                 <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-verified  float-right">
  //                   <div className="mdi mdi-check"> </div>
  //                 </div>
  //               ) : (
  //                   <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-notverified">
  //                   </div>
  //                 )}
  //             </div>

  //             <div className="profile-otherinfo-box-header d-flex justify-content-between mt-3">
  //               <p className="text-left">Police Check</p>
  //               {user.police_check_url ? (
  //                 <h3>View Police Check</h3>
  //               ) : (
  //                   <h3>Not yet added</h3>
  //                 )}
  //             </div>

  //             {user.police_check_expiry ? (
  //               <div className="profile-otherinfo-box-body-cont">
  //                 <div className="profile-otherinfo-box-body">
  //                   Expiry Date: {user.police_check_expiry}
  //                 </div>
  //               </div>
  //             ) : (
  //                 ""
  //               )}
  //           </Link>
  //         ) : (
  //             <div>
  //               <div className="profile-otherinfo-box-header d-flex justify-content-between">
  //                 <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-cont-col-4 ml-3">
  //                   <div className="mdi mdi-fingerprint"> </div>
  //                 </div>
  //                 {user.police_check_verification_status ? (
  //                   <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-verified  float-right">
  //                     <div className="mdi mdi-check"> </div>
  //                   </div>
  //                 ) : (
  //                     <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-notverified">
  //                     </div>
  //                   )}
  //               </div>
  //               <div className="profile-otherinfo-box-header d-flex justify-content-between mt-3">
  //                 <p className="text-left">Police Check</p>
  //                 {user.police_check_url ? (
  //                   <h3>View Police Check</h3>
  //                 ) : (
  //                     <h3>Not yet added</h3>
  //                   )}
  //               </div>

  //               {user.police_check_expiry ? (
  //                 <div className="profile-otherinfo-box-body-cont">
  //                   <div className="profile-otherinfo-box-body">
  //                     Expiry Date: {user.police_check_expiry}
  //                   </div>
  //                 </div>
  //               ) : (
  //                   ""
  //                 )}
  //             </div>
  //           )}
  //       </div>
  //     </div>

  //     <div className="col-2 profile-otherinfo-box-container profile-otherinfo-box-container-smaller">
  //       <div className="profile-otherinfo-box">
  //         {user.wwcc_url ? (
  //           <Link
  //             to={{ pathname: `/PdfViewer?id=${user.wwcc_url}` }}
  //             target="_blank"
  //           >
  //             <div className="profile-otherinfo-box-header d-flex justify-content-between">
  //               <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-cont-col-5 ml-3">
  //                 <div className="mdi mdi-face"> </div>
  //               </div>
  //               {user.wwcc_verification_status ? (
  //                 <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-verified  float-right">
  //                   <div className="mdi mdi-check"> </div>
  //                 </div>
  //               ) : (
  //                   <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-notverified">
  //                   </div>
  //                 )}
  //             </div>
  //             <div className="profile-otherinfo-box-header d-flex justify-content-between mt-3">
  //               <p className="text-left">WWCC</p>
  //               {user.wwcc_url ? (
  //                 <h3>View Working With Children Check (WWCC)</h3>
  //               ) : (
  //                   <h3>Not yet added</h3>
  //                 )}
  //             </div>
  //           </Link>
  //         ) : (
  //             <div>
  //               <div className="profile-otherinfo-box-header d-flex justify-content-between">
  //                 <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-cont-col-5 ml-3">
  //                   <div className="mdi mdi-face"> </div>
  //                 </div>
  //                 {user.wwcc_verification_status ? (
  //                   <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-verified  float-right">
  //                     <div className="mdi mdi-check"> </div>
  //                   </div>
  //                 ) : (
  //                     <div className="profile-otherinfo-box-header-picture-cont profile-otherinfo-box-header-picture-notverified">
  //                     </div>
  //                   )}
  //               </div>
  //               <div className="profile-otherinfo-box-header d-flex justify-content-between mt-3">
  //                 <p className="text-left">WWCC</p>
  //                 {user.wwcc_url ? (
  //                   <h3>View Working With Children Check (WWCC)</h3>
  //                 ) : (
  //                     <h3>Not yet added</h3>
  //                   )}
  //               </div>
  //             </div>
  //           )}
  //       </div>
  //     </div>
  //   </div>
  // )

  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={true}
        isShowWhereby={false}
        footer={null}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={true}
        tabVetResumeActive={false}
      >
        <div
          className="guide-tour-icon"
        >
          <HoverIcon
            icon="info"
            circular
            inverted
            className="search-help-icon"
            onClick={() => setShowTour(true)}
            text="Click for guide"
          />
        </div>
        <Tour
          showCloseButton={false}
          accentColor="#79cbca"
          className="tourContent"
          steps={tourSteps}
          isOpen={showTour}
          onRequestClose={closeTour}
        >
          <div className="tour-dot" onClick={closeTour} />
        </Tour>
        <TeacherResume
          user={user}
          isViewAsTeacher={true}
        />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) =>
    dispatch(updateToRoot(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Resume2)
